import ufeApi from 'services/api/ufeApi';
import headerUtils from 'utils/Headers';
import userUtils from 'utils/User';

const { purchaseEventTimeStamp } = headerUtils;

// https://jira.sephora.com/wiki/display/ILLUMINATE/Initialize+PayPal+checkout+API

function initializePayPalCheckout(payload) {
    const url = '/api/checkout/paypal/init';

    const headers = {
        ...purchaseEventTimeStamp()
    };

    // Add defaultSA headers for location-based services (required for BOPIS)
    userUtils.insertSAZipCodeSACountryCodeHeaders(headers);

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default initializePayPalCheckout;
